import React, { useContext } from "react";
import { observer } from "mobx-react";

import {
	EventContext,
	OfferOptionsContext,
	OfferStoreContext,
} from "@gp/components";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { BettingTypeGroup } from ".";
import { BetBuilderModeContext } from "@state/context/bet-builder/BetBuilderModeContext";

export const BettingTypeGroups = observer(function BettingTypeGroups() {
	const { id } = useContext(EventContext);
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;
	const options = useContext(OfferOptionsContext);

	if (store.displayBettingGroup == "favorites") {
		// @ts-expect-error
		return store.favoritesBettingTypeGroups[id].map((group) => (
			<BettingTypeGroup key={group.abrv} group={group} isFavorite />
		));
	}

	if (store.displayBettingGroup == "bet-builder") {
		return (
			<BetBuilderModeContext.Provider value={true}>
				{store.betBuilderBettingType.map((group) => (
					<BettingTypeGroup key={group.abrv} group={group} />
				))}
			</BetBuilderModeContext.Provider>
		);
	}

	if (store.displayBettingGroup === "betting-tips") {
		return store.bettingTypeGroups.map((group) => (
			<BettingTypeGroup key={group.abrv} group={group} />
		));
	}

	if (store.displayBettingGroup !== "all") {
		const group = store.bettingTypeGroups.find(
			(g) => g.abrv === store.displayBettingGroup
		);
		if (!group) {
			store.setDisplayBettingGroup("all");
			return null;
		}
		return <BettingTypeGroup key={group.abrv} group={group} />;
	}

	if (
		store.defaultBettingTypeDisplay &&
		// @ts-expect-error
		options.shouldDisplayShowMore &&
		!store.isExpanded &&
		store.defaultBettingTypeDisplay.length
	) {
		return store.defaultBettingTypeDisplay.map((group) => (
			<BettingTypeGroup key={group.abrv} group={group} />
		));
	}

	return store.bettingTypeGroups.map((group) => (
		<BettingTypeGroup key={group.abrv} group={group} />
	));
});
